import * as React from 'react'

import { MobXProviderContext } from 'mobx-react'
import { classList } from 'react-classlist-helper'

import MeCompanyQuickFilters, {
  IMeCompanyQuickFiltersProps,
} from '~/client/src/shared/components/Filters/MeCompanyQuickFilters/MeCompanyQuickFilters'
import SearchInput from '~/client/src/shared/components/Filters/SearchInput/SearchInput'
import {
  IViewOptionsGroupingProps,
  IViewOptionsSortingProps,
} from '~/client/src/shared/components/ViewOptions/types'
import ViewOptionsDisplay from '~/client/src/shared/components/ViewOptions/ViewOptionsDisplay'

export type IListHeaderSearchProps = Pick<
  React.ComponentProps<typeof SearchInput>,
  'value' | 'onChange' | 'placeholder' | 'autoFocus' | 'testId'
>

export type IListHeaderQuickFiltersProps = Omit<
  IMeCompanyQuickFiltersProps,
  'size' | 'iconOnly'
>

export interface IListHeaderDisplayBarProps {
  search: IListHeaderSearchProps
  quickFilters?: IListHeaderQuickFiltersProps
  filter?: React.ReactNode
  grouping?: IViewOptionsGroupingProps
  sorting?: IViewOptionsSortingProps
}

export function ListHeaderDisplayBar({
  search,
  quickFilters,
  filter,
  grouping,
  sorting,
}: IListHeaderDisplayBarProps): React.ReactElement {
  const { isMobileEnv } = React.useContext(MobXProviderContext) as {
    isMobileEnv?: boolean
  }

  return (
    <div
      data-slot="list-header-display-bar"
      className={classList({
        'tw:flex tw:items-center tw:shrink-0 tw:px-2.5 tw:gap-2 tw:bg-background tw:first:mt-2.5 tw:[[data-slot=list-selector-title]+*_&]:mt-0!': true,
        'tw:h-9': !!isMobileEnv,
        'tw:h-8': !isMobileEnv,
      })}
    >
      <SearchInput
        {...search}
        // Every list owner filters in memory or debounces its own filtering.
        debounceMs={0}
        size={isMobileEnv ? 'lg' : undefined}
        className="tw:flex-1 tw:min-w-0"
      />
      {quickFilters && (
        <MeCompanyQuickFilters
          {...quickFilters}
          iconOnly
          size={isMobileEnv ? 'lg' : 'default'}
        />
      )}
      {filter}
      <ViewOptionsDisplay grouping={grouping} sorting={sorting} />
    </div>
  )
}
